import { jsx as l, jsxs as m } from "@emotion/react/jsx-runtime";
import { SegmentedProgressContainer as v, Segment as B, SegmentedBar as d, SegmentedLabel as V } from "./SegmentedProgressBar.styled.js";
import { Text as j } from "../Text/index.js";
import { Tooltip as y } from "../Tooltip/index.js";
const F = ({
  segments: e,
  height: f = 8,
  hoverDelay: b
}) => {
  const h = e.reduce((o, t) => o + t.value, 0);
  let a = !1;
  const i = e.reduce((o, t, r) => (t.value && o.push(r), o), []), n = i.length ? Math.min(...i) : -1, s = i.length ? Math.max(...i) : -1;
  return /* @__PURE__ */ l(v, { direction: "row", gap: "0", height: f, children: e.map((o, t) => {
    const r = o.value / h * 100, c = t === n, p = t === s, S = a ? "bottom" : "top", u = !!(o.label && (e[t + 1]?.value || o.value));
    return u && (a = !a), /* @__PURE__ */ m(B, { flexValue: r, segment: o, isBeforeFirst: t < n, isLastOrAfter: t >= s, children: [
      o.tooltip ? /* @__PURE__ */ l(y, { ...o.tooltip, hoverDelay: b, children: /* @__PURE__ */ l(d, { flexValue: r, segment: o, isLast: p, isFirst: c }) }) : /* @__PURE__ */ l(d, { flexValue: r, segment: o, isLast: p, isFirst: c }),
      u && /* @__PURE__ */ l(V, { segment: o, position: S, alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ l(j, { variant: "bodySBold", as: "span", color: o.color, children: o.label }) })
    ] }, o.label);
  }) });
};
export {
  F as SegmentedProgressBar
};
